export default "__VITE_ASSET__BvZz37FM__"